import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectAppliedFiltersByViewId = (state, props) => {
  return get(state, `${props.statusViewId}.appliedFilters`, emptyArray);
};
